
import { mapGetters } from 'vuex'
export default {
    name: 'PzNotify',

    data() {
        return {
            timer: null,
            isProcessing: false, // 标记是否正在处理通知队列，避免并发定时器冲突
        }
    },
    computed: {
        ...mapGetters({
            notifyList: 'notify/notifyList',
            bargainBoxList: 'bargaining/bargainBoxList',
        })
    },

    watch: {
        notifyList: {
            handler(newVal) {

                // 仅当有通知且未在处理队列时，启动顺序处理
                if (newVal.length && !this.isProcessing) {
                    console.log('newVal======>>>', newVal);
                    this.processNotifications(); // 传入副本避免原数组引用问题
                }
            },
            deep: true
        },
    },
    methods: {
        /**
         * 关闭通知
         * @param index
         * @param item
         */
        handleCloseNotify(item, index) {
            clearTimeout(this.timer)
            this.timer = null
            const currIndex = this.notifyList.findIndex(e => e.sentTime === item.sentTime)
            this.$store.commit('notify/REMOVE_NOTIFY_LIST', currIndex)
            this.handleStationNotifyRecall('IGNORE', item)
        },
        /**
         * 点击通知
         * @param item
         * @param index
         */
        handleClickNotify(item, index) {
            item.show = false
            const { links } = item
            clearTimeout(this.timer)
            this.timer = null
            if (links.length) {
                const link = links.find(item => item.channel === 'PC')
                console.log('link======>>>', link);
                const { params, url, scene } = link
                const query = params ? `?${params}` : ''
                const queryParams = this.parseQueryString(params)
                switch (link.linkType) {
                    // 内部链接
                    case 'INNER':
                        this.$store.commit('notify/REMOVE_NOTIFY_LIST', index)
                        switch (scene) {
                            case 'NONE':
                                const path = `${url}${query}`
                                this.$router.push(path)
                                break;
                            // 订单群聊
                            case 'ORDER_CHAT':
                                this.$store.commit('ry/SET_GLOBAL_SHOW_CHAT', true)
                                this.$store.commit('ry/SET_CONVERSATION_ACTIVE', 3)
                                break;
                            // 咨询单聊
                            case 'CONSULT_CHAT':
                                this.$store.commit('ry/SET_GLOBAL_SHOW_CHAT', true)
                                this.$store.commit('ry/SET_CONVERSATION_ACTIVE', 2)
                                break;
                            // 砍价聊天
                            case 'BARGAIN_CHAT':
                                // 通过seeeionId 查找到当前会话信息
                                const currConversationInfo = this.bargainBoxList.find(item => item.sessionId === queryParams.sessionId)
                                // 砍价会话是否存在
                                if (currConversationInfo) {
                                    // 设置当前砍价会话信息
                                    this.$store.commit('bargaining/SET_CURRENT_BARGAIN', currConversationInfo)
                                } else {
                                    this.$store.commit('bargaining/SET_CURRENT_BARGAIN', { ...queryParams })
                                }
                                this.$store.commit('ry/SET_GLOBAL_SHOW_CHAT', true)
                                // 设置砍价会话窗口显示
                                this.$store.commit('bargaining/SET_SHOW_BARGAINING', true)
                                // 设置会话类型
                                this.$store.commit('ry/SET_CONVERSATION_ACTIVE', 1)
                                // 砍价类型 0 - 全部， 1 - 发起的砍价，2 - 收到的砍价
                                this.$store.commit('bargaining/SET_BARGAIN_TYPE', 0)
                                // 设置会话激活
                                this.$store.commit('ry/SET_ACTIVE_CONVERSATION_TYPE', queryParams.sessionId)
                                break;
                            default:
                                break;
                        }
                        break;
                    // 外部链接
                    case 'OUTER':
                        window.open(`${link.url}${query}`)
                        this.$store.commit('notify/REMOVE_NOTIFY_LIST', index)
                        break;
                    default:
                        break;
                }
            }
            this.handleStationNotifyRecall('TOUCH', item)
        },
        /**
         * 解析查询字符串
         * @param queryString
         * @returns
         */
        parseQueryString(queryString) {
            if (!queryString)
                return {}
            const params = {}
            // 分割参数对并解析键值
            queryString.split('&').forEach(item => {
                const [key, value] = item.split('=')
                if (key) {
                    params[key] = decodeURIComponent(value || '') // 解码特殊字符（如中文、空格等）
                }
            })
            return params
        },
        /**
         * 站内消息回执事件
         * @param event
         * @param item
         */
        handleStationNotifyRecall(event, item) {
            const data = {
                recalls: [
                    {
                        eventId: item.eventId,
                        event,  // 站内通知未点击或关闭
                    }
                ]
            }
            this.$api.stationNotifyRecall(data)
        },
        /**
         * 顺序处理通知队列
         * @param list 通知列表副本
         */
        async processNotifications(list) {
            // 若队列空，重置处理状态并退出
            if (!this.notifyList.length) {
                this.isProcessing = false;
                this.timer = null;
                return;
            }

            this.isProcessing = true;
            const currentItem = this.notifyList[0]; // 获取当前第一个通知

            //EXPOSURE- 站内通知曝光成功 TOUCH - 站内通知点击 IGNORE - 站内通知未点击,
            this.handleStationNotifyRecall('EXPOSURE', currentItem);
            // 设置当前通知的关闭定时器
            this.timer = setTimeout(() => {
                // 移除当前通知，生成新列表
                const updatedList = [...this.notifyList];
                updatedList.shift(); // 移除已处理通知
                console.log('当前通知处理完成，更新列表:', updatedList);
                // 更新状态并发送回执
                this.$store.commit('notify/SET_NOTIFY_LIST', updatedList);
                this.handleStationNotifyRecall('IGNORE', currentItem);
                this.isProcessing = false
                // 清除定时器，继续处理剩余通知
                clearTimeout(this.timer);
                this.timer = null;
                this.processNotifications(updatedList); // 递归处理下一个通知
            }, 5000); // 5秒后关闭当前通知
        }
    }
}

